/**
 * 圖表座標軸的數字格式化。
 */

/**
 * 金額軸的縮寫：1000 → 1k、1500 → 1.5k、2500 → 2.5k。
 *
 * 不可用 `(v / 1000).toFixed(0) + 'k'` —— 那會把 2500 進位成「3k」、1500 進位成「2k」，
 * 標示出來的數字直接是錯的；而當軸間隔是 500 時 (窄螢幕很常見)，
 * 相鄰兩格還會同時顯示「2k」，看起來像壞掉。實測行動版的訂房曲線右軸就是
 * 「3k 2k 2k 1k 500 0」。
 *
 * 千位以下維持原值：500 就寫 500，寫成 0.5k 反而更難讀。
 */
export const kAxis = (v) => {
  if (v == null || Number.isNaN(Number(v))) return '';
  const n = Number(v);
  if (Math.abs(n) < 1000) return String(n);
  const k = n / 1000;
  // 整數就不帶小數點，1.5k 這種才補一位 —— 軸標籤寬度有限，能省則省
  return (Number.isInteger(k) ? k : Number(k.toFixed(1))) + 'k';
};
